import {Flex, Image} from "antd";
import {Fade} from "react-awesome-reveal";
import img14 from "../../About/images/14.jpeg";
import MyText from "../../../components/UI/Text/MyText";
import {clrs} from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import {Link} from "react-router-dom";
import {LinkOutlined} from "@ant-design/icons";
import React from "react";

export const Person14 = () => {

    return (
        <Flex style={{width: "100%", position: "relative"}} vertical gap={20}>
            <Flex style={{width: "100%", position: "relative"}} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img14} width={300} preview={false} style={{borderRadius: 20}}/>
                </Fade>

                <Flex style={{width: "100%", position: "relative"}} vertical>
                    <MyText strong size={"large"}>
                        Казамбаев Ильяс Маратула
                    </MyText>
                    <MyText style={{color: clrs.whiterBlacker}}>
                        Bachelor of Automation and Control, Master of technical sciences, Doctorate PhD Student of Automation and Management
                    </MyText>
                    <br/>
                    <HorizontalDivider/>
                    <br/>
                    <Flex gap={20} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=58127758600'}>
                            <MyText>
                                <LinkOutlined /> Scopus
                            </MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0003-0850-7490'}>
                            <MyText>
                                <LinkOutlined /> Orcid
                            </MyText>
                        </Link>
                    </Flex>
                    <br/>
                    <MyText strong size={"small"} >
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        ТОО "Astana IT University", младший научный сотрудник, НИЦ "Industry 4.0"
                    </MyText>
                </Flex>
            </Flex>
            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>
                    Роль в проекте или программе, а также характер выполняемой работы
                </MyText>
                <MyText size={"small"} italic>
                    Младший научный сотрудник
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Совместное проведение экспериментальных исследований;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Написание научных статей;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Создание моделей облачной архитектуры программного комплекса, реализованного с использованием технологии микросервисов
                </MyText>
            </Flex>
            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>
                    Краткое обоснование участия
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    Докторант по специальности «Автоматизация и управление» по теме «Разработка интеллектуальной распределённой автоматической системы контроля технического состояния силовых кабелей с использованием волоконно-оптических датчиков». Навыки работы в COMSOL, MatLab, AutoCAD. Знание в электронике, электротехнике, математического моделирования.
                </MyText>
            </Flex>
            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>
                    Научные Проекты, в которых принимал участие:
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Участвует в проекте грантового финансирования на 2022-2024 гг. ИРН AP13067967 «Разработка технологии построения микропроцессорных ресурсосберегающих устройств релейной защиты на основе открытой архитектуры». Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Участвует в проекте грантового финансирования на 2023-2025 гг. ИРН AP19678773 «Разработка технологии интеллектуальной предварительной обработки аэрокосмических изображений для распознавания и идентификации различных объектов». Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Участвует в проекте программно-целевого финансирования на 2023-2025 гг. ИРН BR21882258 «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий в окружающую среду для принятия решения в концепте углеродной нейтральности». Роль –исполнитель.
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - Участвует в проекте программно-целевого финансирования на 2024-2026 гг. ИРН BR24993128 «Разработка информационно-аналитической системы для принятия решений, обеспечивая эффективное использование трансграничных водных ресурсов в сельскохозяйственной отрасли Жамбылского региона». Роль –исполнитель.
                </MyText>
            </Flex>
            <Flex style={{width: "100%", position: "relative"}} vertical>
                <MyText strong size={"small"}>
                    Роль в достижении результатов проекта:
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - совместное проведение экспериментальных исследований, написание научных статей;
                </MyText>
                <MyText size={"small"} style={{paddingLeft: 20}}>
                    - создание моделей облачной архитектуры программного комплекса, реализованного с использованием технологии микросервисов.
                </MyText>
            </Flex>
            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size="small">Публикации по теме проекта:</MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    1. Neftissov, A., Sarinova, A., Kazambayev, I., Kirichenko, L., Kuchanskyi, O., Faizullin, A. Determination of the speed of a microprocessor relay protection device of open architecture with a reed switch and the industrial internet of things. Eastern-European Journal of Enterprise Technologies, 2 (9 (122)), 20–30. DOI: https://doi.org/10.15587/1729-4061.2023.276588. Scopus квартиль – Q3, процентиль – 47.
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    2. Mekhtiyev, A., Dunayev, P., Neshina, Y., Alkina, A., Aimagambetova, R., Mukhambetov, G., Kirichenko, L., Kazambayev, I. Power supply via fiber-optical conductor for sensors of mine working monitoring system. Eastern-European Journal of Enterprise Technologies, 5, 15–23. DOI: 10.15587/1729-4061.2023.289775. Scopus квартиль – Q3.
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    3. Neftissov, A., Sarinova, A., Kazambayev, I., Kirichenko, L., Kuchanskyi, O., Faizullin, A. Determination of the speed of a microprocessor relay protection device of open architecture with a reed switch and the industrial internet of things. Eastern-European Journal of Enterprise Technologies, 2 (9 (122)), 20–30. DOI: https://doi.org/10.15587/1729-4061.2023.276588. Scopus квартиль – Q3, процентиль – 47.
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    4. Neftisov, A.V., Sarinova, A.Zh., Talipov, O.M., Kirichenko, L.N., Kazambayev, I.M. Possibility of building microprocessor relay protection devices on open architecture. Торайғыров университетінің хабаршысы, Энергетикалық сериясы, №3, 2022, pp. 277–292. DOI: 10.48081/RKWX7770. КОКСОН МНиВО РК.
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    5. Biloshchytskyi, A., Kuchansky, A., Andrashko, Y., Neftissov, A., Vatskel, V., Yedilkhan, D., Herych, M. Building a model for choosing a strategy for reducing air pollution based on data predictive analysis. Eastern-European Journal of Enterprise Technologies, 3 (4-117), 2022, pp. 23–30. DOI: 10.15587/1729-4061.2022.259323. Scopus квартиль – Q3, процентиль – 47.
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    6. Mekhtiev, A., Alkina, A., Neftissov, A., Kazambayev, I., Kirichenko, L. Intelligent Systems for Monitoring the Integrity of Technical Objects Based on Distributed Fiber-optic Sensors. CEUR Workshop Proceedings, vol. 3347, 2022, pp. 290–306. Scopus процентиль – 21.
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    7. Mekhtiev, A., Alkina, A., Neftissov, A., Kazambayev, I., Kirichenko, L. Development of an Automatic System for Monitoring the Integrity of Power Cables Using Quasi-Distributed Fiber-Optic Sensors. CEUR Workshop Proceedings, vol. 3347, 2022, pp. 53–68. Процентиль – 21.
                </MyText>

                <MyText size="small" style={{ paddingLeft: 20 }}>
                    8. Neftissov, A., Biloshchytskyi, A., Kazambayev, I., Kirichenko, L., Zhalmagambetova, U., Biloshchytska, S. Analysis of the Existing Air Emissions Detection Methods for Stationary Pollution Sources Monitoring. Applied Sciences, 2024, 14, 10934. DOI: https://doi.org/10.3390/app142310934. Scopus квартиль – Q1.
                </MyText>
            </Flex>

        </Flex>
    );
}